<template>
  <div>
    <div v-if="pageLoading" class="text-center" style="padding: 80px 0;">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Carregando...</span>
      </div>
      <p class="mt-2">Carregando chamado...</p>
    </div>

    <div v-else>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body p-1 pb-1">
              <div class="row">
                <div class="col-md-9 bold fs-16">{{ call.title }}</div>
                <div
                  class="col-md-3 d-flex justify-content-end align-items-center"
                  style="gap: 12px"
                  v-if="isAccessNivel8 || isAccessNivel20 || !isAuthor"
                >
                  <button
                    class="btn btn-sm btn-primary"
                    data-toggle="modal"
                    data-target="#alterResponsible"
                  >
                    Alterar Responsável
                  </button>
                  <button
                    class="btn btn-sm btn-primary"
                    data-toggle="modal"
                    data-target="#alterStatus"
                  >
                    Alterar Status
                  </button>
                  <button
                    class="btn btn-sm btn-success"
                    @click="assumirChamado()"
                    v-if="call.dev_acting == 0 && call.status != 9"
                  >
                    Assumir Chamado
                  </button>
                  <button
                    class="btn btn-sm btn-danger"
                    data-toggle="modal"
                    data-target="#deleteModal"
                    v-if="call.status != 9"
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="card-footer" style="background: #ddd !important">
            <div class="col-md-12 text-center">
              <h5 class="mb-2 ml-1">Progresso Total</h5>
            </div>
            <div class="row d-flex justify-content-center align-items-top">
              <div
                class="col-md-3 p-0 card text-center"
                v-if="call.status >= 0"
              >
                <div class="card-header pt-1 pb-1 text-light bg-secondary">
                  Chamado Aberto<br />({{ call.data_error_f }})
                </div>
                <div class="card-body mt-1 text-left font-low">
                  {{ call.description_error }}
                </div>
              </div>
              <div
                class="col-md-4 row"
                v-for="progress in ticketProgress"
                :key="progress.id"
              >
                <div
                  class="col-md-3 d-flex align-items-center justify-content-center"
                  style="min-height: 100%"
                >
                  <i
                    class="fas fa-arrow-right"
                    style="font-size: 30px; max-height: 35px"
                  ></i>
                </div>
                <div class="col-md-9 p-0 card text-center">
                  <div
                    :class="
                      'card-header pt-1 pb-1 text-light bg-' + progress.class
                    "
                  >
                    {{ progress.type }} ({{
                      progress ? progress.created_at_f : ""
                    }})
                  </div>
                  <div
                    class="card-body mt-1 text-left font-low"
                    v-html="progress.text"
                  ></div>
                </div>
              </div>
              <div class="col-md-4 row" v-if="call.status === 9">
                <div
                  class="col-md-3 d-flex align-items-center justify-content-center"
                  style="min-height: 100%"
                >
                  <i
                    class="fas fa-arrow-right"
                    style="font-size: 30px; max-height: 35px"
                  ></i>
                </div>
                <div class="col-md-9 p-0 card text-center">
                  <div class="card-header pt-1 pb-1 text-light bg-danger">
                    Cancelado ({{ cancel ? cancel.created_at_f : "" }})
                  </div>
                  <div
                    class="card-body mt-1 text-left font-low"
                    v-html="cancel.description"
                  ></div>
                </div>
              </div>
            </div>
          </div> -->
          <div class="row">
            <div class="col-md-7 col-lg-8 col-xl-9 col-12">
              <div
                class="card"
                :style="call.status_calls.badge_description_next"
              >
                <div class="card-body">
                  <div class="row">
                    <div
                      class="d-flex justify-content-between flex-column col-xl-7 col-21"
                    >
                      <div class="d-flex justify-content-start">
                        <span
                          class="b-avatar badge-light-danger rounded"
                          :style="
                            userDataFullscreen
                              ? 'width: 104px; height: 104px'
                              : 'width: 40px; height: 40px'
                          "
                          ><span class="b-avatar-img"
                            ><img
                              src="@/assets/images/avatars/default.png"
                              alt="avatar" /></span
                        ></span>
                        <div class="d-flex flex-column ml-1">
                          <div :class="userDataFullscreen ? 'mb-1' : ''">
                            <h4
                              class="mb-0 d-flex align-items-center"
                              style="gap: 6px"
                            >
                              <span>{{
                                call.user_model
                                  ? call.user_model.name
                                  : "Não informado"
                              }}</span>

                              <!-- Ícone de editar -->
                              <i
                                class="fas fa-pencil-alt text-primary"
                                style="cursor: pointer; font-size: 15px"
                                data-toggle="modal"
                                data-target="#editUserName"
                                v-if="isAccessNivel8 || isAccessNivel20"
                              ></i>
                            </h4>
                            <span class="card-text" v-if="call.user_model"
                              ><a :mailto="call.user_model.email">{{
                                call.user_model.email
                              }}</a></span
                            >
                            <br v-if="userDataFullscreen" />
                            <br v-if="userDataFullscreen" />
                            <span
                              class="badge mr-1 fs-14"
                              :class="call.status_calls.badge_description"
                              v-if="userDataFullscreen"
                            >
                              {{ call.status_calls.description }}</span
                            >
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div
                          class="d-flex justify-content-start align-items-center"
                          style="gap: 14px; margin-top: 8px; margin-bottom: 8px"
                        >
                          <button
                            class="btn btn-sm btn-primary btn-hover-white"
                            data-toggle="modal"
                            data-target="#changePriority"
                            v-if="
                              isAccessNivel8 ||
                              isAccessNivel20 ||
                              (!isAuthor && call.status != 9)
                            "
                          >
                            <i class="fas fa-asterisk"></i> Alterar Prioridade
                          </button>
                          <button
                            class="btn btn-sm btn-primary btn-hover-white"
                            data-toggle="modal"
                            data-target="#changeSystem"
                            v-if="call.status != 9"
                          >
                            <i class="fas fa-sitemap"></i> Alterar Sistema
                          </button>
                          <button
                            class="btn btn-sm btn-primary btn-hover-white"
                            data-toggle="modal"
                            data-target="#changeDeadline"
                            v-if="
                              isAccessNivel8 ||
                              isAccessNivel20 ||
                              (!isAuthor && call.status != 9)
                            "
                          >
                            <i class="far fa-calendar-check"></i> Alterar Prazo
                          </button>
                          <button
                            class="btn btn-sm btn-primary btn-hover-white"
                            data-toggle="modal"
                            data-target="#changeDepartment"
                            v-if="call.status != 9"
                          >
                            <i class="far fa-building"></i> Alterar Departamento
                          </button>
                        </div>
                      </div>

                      <div
                        class="d-flex align-items-center"
                        v-if="userDataFullscreen"
                      >
                        <div class="d-flex align-items-center mr-2">
                          <span class="b-avatar badge-light-primary rounded"
                            ><i class="far fa-clock" style="font-size: 18px"></i
                          ></span>
                          <div class="ml-1">
                            <h5 class="mb-0">{{ call.diff_in_hours }}</h5>
                            <small>Tempo desde a abertura</small>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-5 col-12" v-if="userDataFullscreen">
                      <table class="mt-2 mt-xl-0 w-100">
                        <tr>
                          <th class="pb-50">
                            <i class="fas fa-sitemap mr-75"></i>
                            <span class="font-weight-bold">Sistema</span>
                          </th>
                          <td class="pb-50">
                            {{ call.project ? call.project.name : "" }}
                          </td>
                        </tr>
                        <tr>
                          <th class="pb-50">
                            <i class="fas fa-building mr-75"></i>
                            <span class="font-weight-bold">Cliente</span>
                          </th>
                          <td class="pb-50 text-capitalize">
                            {{ call.client ? call.client.company_name : "" }}
                          </td>
                        </tr>
                        <tr>
                          <th class="pb-50">
                            <i class="fas fa-user mr-75"></i>
                            <span class="font-weight-bold"
                              >Contato do Cliente</span
                            >
                          </th>
                          <td class="pb-50 text-capitalize">
                            {{
                              call.client_contact
                                ? call.client_contact.name
                                : ""
                            }}
                          </td>
                        </tr>
                        <tr>
                          <th class="pb-50">
                            <i class="fas fa-i-cursor"></i>
                            <span class="font-weight-bold ml-1"
                              >Tipo do Chamado</span
                            >
                          </th>
                          <td class="pb-50 text-capitalize">
                            {{ call.type_call ? call.type_call.name : "" }}
                          </td>
                        </tr>
                        <tr>
                          <th class="pb-50">
                            <i class="far fa-calendar-check"></i>
                            <span class="font-weight-bold ml-1">Prazo</span>
                          </th>
                          <td class="pb-50 text-capitalize">
                            {{
                              call.deadline_f
                                ? call.deadline_f
                                : "Não informado"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <th class="pb-50">
                            <i class="fas fa-asterisk"></i>
                            <span class="font-weight-bold ml-1"
                              >Prioridade</span
                            >
                          </th>
                          <td class="pb-50 text-capitalize">
                            {{ call.priority }}
                          </td>
                        </tr>
                        <tr v-if="call.department_id">
                          <th class="pb-50">
                            <i class="fas fa-flag"></i>
                            <span class="font-weight-bold ml-1"
                              >Departamento</span
                            >
                          </th>
                          <td class="pb-50 text-capitalize">
                            {{ call.department.name }}
                          </td>
                        </tr>
                        <tr>
                          <th class="pb-50">
                            <i class="fas fa-code-branch mr-75"></i>
                            <span class="font-weight-bold">Release</span>
                          </th>
                          <td class="pb-50">
                            <div
                              class="d-flex align-items-center flex-wrap"
                              style="gap: 6px"
                            >
                              <span
                                v-if="call.release"
                                class="badge badge-primary"
                                style="font-size: 12px; cursor: pointer"
                                title="Ver chamados desta release"
                                @click="
                                  $refs.releaseTicketsModal.open(call.release)
                                "
                              >
                                {{ call.release.version_string }} —
                                {{ call.release.name }}
                              </span>
                              <span v-else class="text-muted">—</span>
                              <button
                                v-if="isAccessNivel8"
                                class="btn btn-sm btn-crud view"
                                @click="openTicketReleaseModal"
                              >
                                <i class="fas fa-code-branch"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </table>

                      <div class="d-flex align-items-center mt-3">
                        <span
                          class="b-avatar rounded"
                          :class="
                            call.sla.proximity == 1
                              ? 'badge-light-success'
                              : call.sla.proximity == 2
                              ? 'badge-light-warning'
                              : 'badge-light-danger'
                          "
                          ><i class="far fa-clock" style="font-size: 18px"></i
                        ></span>
                        <div class="ml-1">
                          <h5 class="mb-0">{{ call.sla.text }}</h5>
                          <small>SLA</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-lg-4 col-xl-3 col-12">
              <div class="card border-primary">
                <div
                  class="card-header d-flex justify-content-between align-items-center pt-75 pb-25"
                  :class="!userDataFullscreen ? 'mb-2' : ''"
                >
                  <h5 class="mb-0" style="font-weight: bold; font-size: 20px">
                    #{{ call.id.toString().padStart(6, "0") }}
                  </h5>
                  <h2 style="color: blue; margin-top: 5px; margin-right: -35px">
                    <span id="timer"></span>
                    <i
                      class="fas fa-clock fa-spin ml-1 mr-2"
                      style="font-size: 24px; color: blue; margin-bottom: -5px"
                    ></i>
                  </h2>

                  <small class="text-muted w-100">Nº do Chamado</small>
                </div>
                <div class="card-body" v-if="userDataFullscreen">
                  <ul class="list-unstyled my-1">
                    <li>
                      <span class="align-middle">
                        <h5 style="font-weight: bold; font-size: 14px">
                          {{ call.created_at_f }}
                        </h5>
                        <small class="text-muted"
                          >Data de Abertura do Chamado</small
                        >
                      </span>
                    </li>
                    <li class="mt-1">
                      <span class="align-middle">
                        <h5
                          class="mb-0"
                          style="
                            font-weight: bold;
                            font-size: 18px;
                            margin-bottom: -15px;
                          "
                        >
                          {{ call.dev ? call.dev.name : "Não atribuído" }}
                        </h5>
                        <small class="text-muted w-100"
                          >Pessoa Responsável</small
                        >
                      </span>
                    </li>
                  </ul>
                </div>

                <!-- Botões de módulos — sempre visíveis no card -->
                <div class="card-body pt-0 pb-2" v-if="call.id">
                  <div class="d-flex flex-column" style="gap: 8px">
                    <!-- Intercorrências (oculto para access_nivel 10) -->
                    <button
                      v-if="$store.state.user.perfil_id != 10"
                      class="btn btn-block d-flex align-items-center justify-content-between"
                      :class="occurrencesButtonClass"
                      @click="showOccurrencesModal = true"
                    >
                      <span>
                        <i class="fas fa-exclamation-triangle mr-1"></i>
                        Intercorrências
                      </span>
                      <span>
                        <span
                          class="badge badge-dark mr-1"
                          v-if="occurrencesSummary.length"
                        >
                          {{ occurrencesSummary.length }}
                        </span>
                        <span
                          class="badge badge-danger"
                          v-if="occurrencesPendingCount"
                        >
                          {{ occurrencesPendingCount }} pendente(s)
                        </span>
                      </span>
                    </button>

                    <!-- Cenários de Teste -->
                    <button
                      class="btn btn-block d-flex align-items-center justify-content-between"
                      :class="scenariosButtonClass"
                      @click="showScenariosModal = true"
                    >
                      <span>
                        <i class="fas fa-flask mr-1"></i>
                        Cenários de Teste
                      </span>
                      <span>
                        <span
                          class="badge badge-dark mr-1"
                          v-if="scenariosSummary.length"
                        >
                          {{ scenariosSummary.length }}
                        </span>
                        <span
                          class="badge badge-danger"
                          v-if="scenariosPendingCount"
                        >
                          {{ scenariosPendingCount }} pendente(s)
                        </span>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Informações Adicionais</h5>
                  <div class="row">
                    <div class="col-md-4">
                      <label>Usuário do Sistema</label>
                      <input
                        v-model="call.user"
                        id="name"
                        class="form-control"
                        type="text"
                        disabled
                      />
                    </div>
                    <div class="col-md-3">
                      <label>Módulo</label>
                      <input
                        class="form-control"
                        type="text"
                        id="name"
                        placeholder="Ex. Dashboard, Usuário, etc"
                        v-model="call.method_error"
                        disabled
                      />
                    </div>
                    <div class="col-md-3">
                      <label>Requisição</label>
                      <input
                        class="form-control"
                        type="text"
                        id="name"
                        placeholder="Ex. Criar, Editar, etc..."
                        v-model="call.request_error"
                        disabled
                      />
                    </div>
                    <div class="col-md-2">
                      <label>Data e Hora do Erro</label>
                      <input
                        v-model="call.data_error"
                        class="form-control"
                        type="datetime-local"
                        disabled
                      />
                    </div>
                    <div class="col-md-12 mt-1">
                      <label>Descrição</label>
                      <ckeditor
                        v-model="call.description_error"
                        :editor="editor"
                        :config="editorDisabledConfig"
                        disabled
                      />
                    </div>
                    <!-- === Arquivo enviado na abertura (campo file) === -->
                    <div class="col-md-12 mt-2" v-if="call.file_url">
                      <label>Arquivo enviado na abertura</label>
                      <p class="mb-0 mt-1">
                        <a
                          :href="call.file_url"
                          target="_blank"
                          class="btn btn-sm btn-outline-primary"
                        >
                          <i class="fas fa-paperclip mr-1"></i>
                          Abrir arquivo
                        </a>
                      </p>
                    </div>
                    <!-- === Anexos do Chamado (independente de Interações) === -->
                    <div class="col-md-12 mt-2">
                      <label>Anexos do Chamado</label>

                      <!-- Ações -->
                      <div class="d-flex align-items-center" style="gap: 10px">
                        <button
                          class="btn btn-sm btn-primary btn-hover-white"
                          @click="$refs.ticketFilesInput.click()"
                        >
                          Selecionar arquivos
                        </button>

                        <button
                          class="btn btn-sm btn-success"
                          :disabled="
                            !pendingTicketFiles.length || uploadingTicketFiles
                          "
                          @click="uploadTicketFiles"
                        >
                          <i class="fas fa-upload"></i>
                          {{
                            uploadingTicketFiles
                              ? "Enviando..."
                              : "Enviar arquivos"
                          }}
                        </button>

                        <!-- Só aparece se já houver anexos salvos -->
                        <button
                          v-if="ticketFiles.length"
                          class="btn btn-sm btn-secondary"
                          @click="showFilesModal = true"
                          title="Ver/baixar anexos do chamado"
                        >
                          Arquivos anexados ({{ ticketFiles.length }})
                        </button>
                      </div>

                      <!-- Input de seleção (oculto) -->
                      <input
                        ref="ticketFilesInput"
                        type="file"
                        multiple
                        style="display: none"
                        @change="onTicketFilesSelected"
                      />

                      <!-- Lista de arquivos pendentes (pré-envio) -->
                      <div v-if="pendingTicketFiles.length" class="mt-1">
                        <strong>Pendentes:</strong>
                        <ul class="mb-0 pl-3">
                          <li v-for="(f, i) in pendingTicketFiles" :key="i">
                            {{ f.name }} ({{ (f.size / 1024).toFixed(1) }} KB)
                            <button
                              type="button"
                              class="btn btn-link p-0 ml-2"
                              @click="pendingTicketFiles.splice(i, 1)"
                            >
                              remover
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <!-- Modal: lista de anexos já enviados (download) -->
                    <div
                      v-if="showFilesModal"
                      class="modal-backdrop-custom"
                      @click.self="showFilesModal = false"
                    >
                      <div class="custom-modal">
                        <div class="modal-header">
                          <span>Arquivos anexados ao chamado</span>
                          <button @click="showFilesModal = false">×</button>
                        </div>
                        <div class="modal-body">
                          <template v-if="ticketFiles.length">
                            <ul style="padding: 0; margin: 0">
                              <li v-for="f in ticketFiles" :key="f.id">
                                <a
                                  :href="ticketFileUrl(f)"
                                  target="_blank"
                                  rel="noopener"
                                >
                                  {{
                                    f.original_name ||
                                    (f.file
                                      ? f.file.split("/").pop()
                                      : "Arquivo")
                                  }}
                                </a>
                              </li>
                            </ul>
                          </template>
                          <template v-else>
                            <em>Nenhum arquivo enviado ainda.</em>
                          </template>
                        </div>
                        <div class="modal-footer" style="text-align: right">
                          <button
                            class="btn btn-secondary"
                            @click="showFilesModal = false"
                          >
                            Fechar
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <hr />
                    </div>
                    <div class="col-md-12" v-if="call.json">
                      <label>JSON</label>
                      <json-viewer
                        :value="call.json"
                        :expand-depth="5"
                        copyable
                        boxed
                        sort
                      ></json-viewer>
                    </div>
                    <div class="col-md-12 mt-1" v-if="call.url_system">
                      <label>URL</label>
                      <input
                        v-model="call.url_system"
                        class="form-control"
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Interações -->
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Interações</h5>
                  <div class="row">
                    <div class="col-md-12">
                      <label>Nova Interação</label>
                      <ckeditor
                        v-model="interaction.description"
                        :editor="editor"
                        :config="editorConfig"
                      />
                    </div>

                    <!-- Campo de anexos -->
                    <div class="col-md-12 mt-2">
                      <label>Anexos</label>
                      <input
                        type="file"
                        class="form-control"
                        multiple
                        @change="onFileChange"
                      />

                      <!-- Lista de arquivos selecionados -->
                      <div v-if="files.length" class="mt-1">
                        <ul class="mb-0 pl-3">
                          <li v-for="(f, i) in files" :key="i">
                            {{ f.name }} ({{ (f.size / 1024).toFixed(1) }} KB)
                            <button
                              type="button"
                              class="btn btn-link p-0 ml-2"
                              @click="files.splice(i, 1)"
                            >
                              remover
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div
                      class="col-md-12 text-right mt-1 d-flex justify-content-end gap-2"
                    >
                      <button
                        class="btn btn-success"
                        @click="loadAutoMessages(call.status)"
                        v-if="
                          $store.state.user.perfil_id != 10 &&
                          $store.state.user.perfil_id != 1
                        "
                      >
                        <i class="fas fa-magic"></i> Preencher mensagem
                        automática
                      </button>
                      <button
                        class="btn btn-primary ml-2"
                        @click="saveInteraction"
                      >
                        <i class="fas fa-save"></i> Salvar Interação
                      </button>
                    </div>

                    <div class="col-md-12 mt-3">
                      <div
                        class="row"
                        v-for="interact in call_interactions"
                        :key="interact.id"
                      >
                        <div class="col-md-12">
                          <div
                            class="card"
                            :class="
                              interact.actor == 0
                                ? user_logged != interact.user_id &&
                                  interact.actor == 0
                                  ? 'gray-50'
                                  : 'gray-100'
                                : 'blue'
                            "
                          >
                            <div class="card-body">
                              <h5
                                class="card-title"
                                :class="
                                  user_logged != interact.user_id
                                    ? 'text-right'
                                    : ''
                                "
                                style="
                                  font-size: 14px;
                                  font-style: italic;
                                  font-weight: bold;
                                "
                              >
                                {{ interact.user.name }} em
                                {{ interact.created_at_f }}
                              </h5>
                              <p class="card-text">
                                <span v-html="interact.description"></span>
                              </p>
                              <!-- Lista de anexos -->
                              <div
                                v-if="interact.files && interact.files.length"
                                class="mt-1"
                              >
                                <strong>Anexos:</strong>
                                <ul class="mt-1">
                                  <li v-for="f in interact.files" :key="f.id">
                                    <a
                                      :href="interactionFileUrl(f)"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {{
                                        f.original_name || f.name || "Arquivo"
                                      }}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Alterar Responsável (NOVA E ELEGANTE) -->
    <div
      class="modal fade"
      id="alterResponsible"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content elegant-modal">
          <div class="modal-header elegant-header">
            <h5 class="modal-title">Alterar Responsável</h5>
            <button type="button" class="close" data-dismiss="modal">
              <span>&times;</span>
            </button>
          </div>

          <div class="modal-body elegant-body">
            <label class="modal-label">Selecione o novo responsável</label>

            <v-select
              v-model="call.dev_acting"
              :options="allusers"
              :reduce="(u) => u.id"
              label="name"
              class="vselect-full"
            ></v-select>

            <label class="modal-label mt-3">Motivo da alteração</label>
            <ckeditor v-model="text_responsable" :editor="editor" />
          </div>

          <div class="modal-footer elegant-footer">
            <button class="btn btn-secondary" data-dismiss="modal">
              Cancelar
            </button>
            <button
              class="btn btn-primary"
              data-dismiss="modal"
              @click="saveAlterResponsible"
            >
              Alterar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de alterar status -->

    <div
      class="modal fade"
      id="alterStatus"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content elegant-modal">
          <div class="modal-header elegant-header">
            <h5 class="modal-title">Alterar Status</h5>
            <button type="button" class="close" data-dismiss="modal">
              <span>&times;</span>
            </button>
          </div>

          <div class="modal-body elegant-body">
            <label class="modal-label">Selecione o novo status</label>

            <v-select
              v-model="call_status_id"
              :options="allstatus"
              :reduce="(s) => s.status"
              label="description"
              class="vselect-full"
            ></v-select>

            <label class="modal-label mt-3">Motivo da alteração</label>
            <ckeditor v-model="text" :editor="editor" />
          </div>

          <div class="modal-footer elegant-footer">
            <button class="btn btn-secondary" data-dismiss="modal">
              Cancelar
            </button>
            <button
              class="btn btn-primary"
              data-dismiss="modal"
              @click="saveAlterStatus()"
            >
              Alterar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de deletar chamado -->

    <div
      class="modal fade"
      id="deleteModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="title"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="title">Cancelar Chamado</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <label>Descreva o motivo do cancelamento</label>
            <ckeditor
              v-model="delete_text"
              :editor="editor"
              :disabled="loading_cancel"
            />
            <div class="row mt-1">
              <button
                class="btn btn-sm offset-1 col-md-3"
                style="border: 2px solid #4b56eb"
                @click="sugestion(1)"
                :disabled="loading_cancel"
              >
                Chamado em duplicidade
              </button>
              <button
                class="btn btn-sm offset-1 col-md-6"
                style="border: 2px solid #4b56eb"
                @click="sugestion(2)"
                :disabled="loading_cancel"
              >
                Problema corrigido na próxima versão
              </button>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              :disabled="loading_cancel"
            >
              Fechar
            </button>
            <button
              type="button"
              class="btn btn-danger"
              @click="deleleTicket()"
              :disabled="loading_cancel"
            >
              <span
                v-if="loading_cancel"
                class="spinner-border spinner-border-sm mr-1"
                role="status"
                aria-hidden="true"
              ></span>
              {{ loading_cancel ? "Cancelando..." : "Cancelar Chamado" }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de alterar prazo -->

    <div
      class="modal fade"
      id="changeDeadline"
      tabindex="-1"
      role="dialog"
      aria-labelledby="title"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="title">Alterar Prazo</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <label>Qual o prazo para este chamado?</label>
            <input
              type="datetime-local"
              v-model="call.deadline"
              class="form-control"
            />
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="alterDeadline()"
            >
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de alterar Departamento -->
    <div
      class="modal fade"
      id="changeDepartment"
      tabindex="-1"
      role="dialog"
      aria-labelledby="title"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="title">Alterar Departamento</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <label>Para qual departamento deseja alterar?</label>
            <v-select
              v-model="call.department_id"
              :options="departments"
              :reduce="(dept) => dept.id"
              :label="'name'"
            ></v-select>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="alterDepartment()"
            >
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de alterar prioridade -->

    <div
      class="modal fade"
      id="changePriority"
      tabindex="-1"
      role="dialog"
      aria-labelledby="title"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="title">Alterar Prazo</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <label>Qual a prioridade para este chamado?</label>
            <select v-model="call.priority" class="form-control">
              <option value="🔵">🔵 Ultra baixa prioridade</option>
              <option value="🟢">🟢 Baixa prioridade</option>
              <option value="🟡">🟡 Média prioridade</option>
              <option value="🔴">🔴 Alta prioridade</option>
            </select>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="alterPriority()"
            >
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="changeSystem"
      tabindex="-1"
      role="dialog"
      aria-labelledby="title"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="title">Alterar Sistema</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <label>Para qual sistema deseja alterar?</label>
            <v-select
              v-model="call.system_error_id"
              :options="systems"
              :reduce="(systems) => systems.id"
              :label="'name'"
            ></v-select>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="alterSystem()"
            >
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para Editar Nome do Usuário -->
    <div
      class="modal fade"
      id="editUserName"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Editar Nome do Usuário</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span>&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <label>Selecione um usuário</label>
            <v-select
              v-model="selectedUserId"
              :options="allusers"
              :reduce="(user) => user.id"
              label="name"
              placeholder="Escolha um usuário"
            ></v-select>
          </div>

          <div class="modal-footer">
            <button class="btn btn-secondary" data-dismiss="modal">
              Cancelar
            </button>
            <button
              class="btn btn-primary"
              data-dismiss="modal"
              @click="saveEditedUserName"
            >
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Mensagem Automática -->
    <div
      v-if="showAutoModal"
      class="modal-backdrop-custom"
      @click.self="showAutoModal = false"
    >
      <div class="custom-modal">
        <div class="modal-header">
          <span>Escolha uma mensagem automática</span>
        </div>
        <div class="modal-body">
          <ul style="padding: 0; margin: 0">
            <li
              v-for="msg in autoMessages"
              :key="msg.id"
              style="
                list-style: none;
                margin-bottom: 12px;
                cursor: pointer;
                background: #232940;
                border-radius: 7px;
                padding: 12px;
                transition: 0.2s;
              "
              @click="fillFromAutoMessage(msg)"
            >
              {{ msg.description }}
            </li>
          </ul>
        </div>
        <div class="modal-footer" style="text-align: right">
          <button class="btn btn-secondary" @click="showAutoModal = false">
            Fechar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal: Vincular Release ao Chamado -->
    <div
      class="modal fade"
      id="ticketReleaseModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Release — Chamado #{{
                call.id ? call.id.toString().padStart(6, "0") : ""
              }}
            </h5>
            <button type="button" class="close" data-dismiss="modal">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="call.release">
              <p class="mb-2">
                Vinculado a:
                <strong class="text-primary">
                  {{ call.release.version_string }} — {{ call.release.name }}
                </strong>
              </p>
              <button
                class="btn btn-danger btn-sm"
                @click="detachReleaseFromTicket"
                :disabled="savingTicketRelease"
              >
                <i class="fas fa-unlink mr-1"></i>
                {{
                  savingTicketRelease ? "Removendo..." : "Remover da release"
                }}
              </button>
            </div>
            <div v-else>
              <div class="form-group mb-0">
                <label>Selecionar Release</label>
                <v-select
                  v-model="ticketSelectedReleaseId"
                  :options="ticketModalReleases"
                  :reduce="(r) => r.id"
                  label="release_label"
                  placeholder="Selecione uma release..."
                ></v-select>
              </div>
              <small
                class="text-muted"
                v-if="!ticketModalReleases.length && call.system_error_id"
              >
                Nenhuma release disponível para este sistema.
              </small>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
            <button
              v-if="!call.release"
              type="button"
              class="btn btn-primary"
              @click="attachReleaseToTicket"
              :disabled="savingTicketRelease || !ticketSelectedReleaseId"
            >
              <i class="fas fa-link mr-1"></i>
              {{ savingTicketRelease ? "Vinculando..." : "Vincular" }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal: Chamados da Release -->
    <release-tickets-modal ref="releaseTicketsModal"></release-tickets-modal>

    <!-- Modal: Intercorrências -->
    <div
      v-if="showOccurrencesModal"
      class="module-modal-backdrop"
      @click.self="showOccurrencesModal = false"
    >
      <div class="module-modal-content">
        <div class="module-modal-header">
          <h5 class="mb-0">
            <i class="fas fa-exclamation-triangle text-warning mr-2"></i
            >Intercorrências
          </h5>
          <button
            class="btn btn-sm btn-light"
            @click="
              showOccurrencesModal = false;
              fetchModuleSummaries(call.id);
            "
          >
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="module-modal-body">
          <call-occurrences
            :call-id="call.id"
            v-if="call.id && showOccurrencesModal"
          ></call-occurrences>
        </div>
      </div>
    </div>

    <!-- Modal: Cenários de Teste -->
    <div
      v-if="showScenariosModal"
      class="module-modal-backdrop"
      @click.self="showScenariosModal = false"
    >
      <div class="module-modal-content">
        <div class="module-modal-header">
          <h5 class="mb-0">
            <i class="fas fa-flask text-info mr-2"></i>Cenários de Teste
          </h5>
          <button
            class="btn btn-sm btn-light"
            @click="
              showScenariosModal = false;
              fetchModuleSummaries(call.id);
            "
          >
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="module-modal-body">
          <call-test-scenarios
            :call-id="call.id"
            v-if="call.id && showScenariosModal"
          ></call-test-scenarios>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import JsonViewer from "vue-json-viewer";
import ReleaseTicketsModal from "../../components/ReleaseTicketsModal";
import CallOccurrences from "./CallOccurrences";
import CallTestScenarios from "./CallTestScenarios";

class MyUploadAdapter {
  constructor(loader) {
    // The file loader instance to use during the upload.
    this.loader = loader;
  }

  // Starts the upload process.
  upload() {
    // Update the loader's progress.
    if (!this.loader || !this.loader.file) {
      return Promise.reject("No file to upload");
    }

    return this.loader.file
      .then((file) => {
        if (!file) {
          return Promise.reject("Invalid file");
        }
        return new Promise((resolve, reject) => {
          this._initRequest();
          this._initListeners(resolve, reject, file);
          this._sendRequest(file);
        });
      })
      .catch((error) => {
        console.error("Upload error:", error);
        return Promise.reject(error);
      });
  }

  // Aborts the upload process.
  abort() {
    // Reject the promise returned from the upload() method.
    if (this.xhr) {
      this.xhr.abort();
    }
  }

  // Initializes the XMLHttpRequest object using the URL passed to the constructor.
  _initRequest() {
    const xhr = (this.xhr = new XMLHttpRequest());

    // Note that your request may look different. It is up to you and your editor
    // integration to choose the right communication channel. This example uses
    // a POST request with JSON as a data structure but your configuration
    // could be different.
    xhr.open(
      "POST",
      "https://api.intranet.it4d.com.br/api/v1/images/upload",
      true
    );
    xhr.responseType = "json";
  }

  // Initializes XMLHttpRequest listeners.
  _initListeners(resolve, reject, file) {
    const xhr = this.xhr;
    const loader = this.loader;

    if (!file || !file.name) {
      return reject("Invalid file object");
    }

    const genericErrorText = `Couldn't upload file: ${file.name}.`;

    xhr.addEventListener("error", () => reject(genericErrorText));
    xhr.addEventListener("abort", () => reject());
    xhr.addEventListener("load", () => {
      const response = xhr.response;

      // This example assumes the XHR server's "response" object will come with
      // an "error" which has its own "message" that can be passed to reject()
      // in the upload promise.
      //
      // Your integration may handle upload errors in a different way so make sure
      // it is done properly. The reject() function must be called when the upload fails.
      if (!response || response.error) {
        return reject(
          response && response.error ? response.error.message : genericErrorText
        );
      }

      // If the upload is successful, resolve the upload promise with an object containing
      // at least the "default" URL, pointing to the image on the server.
      // This URL will be used to display the image in the content. Learn more in the
      // UploadAdapter#upload documentation.
      resolve({
        default: response.url,
      });
    });

    // Upload progress when it is supported. The file loader has the #uploadTotal and #uploaded
    // properties which are used e.g. to display the upload progress bar in the editor
    // user interface.
    if (xhr.upload && loader) {
      xhr.upload.addEventListener("progress", (evt) => {
        if (evt.lengthComputable) {
          loader.uploadTotal = evt.total;
          loader.uploaded = evt.loaded;
        }
      });
    }
  }

  // Prepares the data and sends the request.
  _sendRequest(file) {
    // Prepare the form data.
    const data = new FormData();

    data.append("upload", file);

    // Important note: This is the right place to implement security mechanisms
    // like authentication and CSRF protection. For instance, you can use
    // XMLHttpRequest.setRequestHeader() to set the request headers containing
    // the CSRF token generated earlier by your application.

    // Send the request.
    this.xhr.send(data);
  }
}

function MyUploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = function (loader) {
    return new MyUploadAdapter(loader);
  };
}

// Botão personalizado de Upload de Arquivo (PDF, ZIP, DOCX, XLSX, etc.)
function FileUploadPlugin(editor) {
  editor.ui.componentFactory.add("uploadFile", (locale) => {
    const view = new editor.ui.button.ButtonView(locale);

    view.set({
      label: "Anexar Arquivo",
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M19 14v6a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-6h2v6h10v-6zm-6-10l5 5h-3v6h-4v-6H8l5-5z"/></svg>',
      tooltip: true,
    });

    view.on("execute", () => {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "*/*";

      input.onchange = async (e) => {
        const file = e.target.files[0];
        const loader = editor.plugins.get("FileRepository").createLoader(file);

        loader.upload().then((result) => {
          const url = result.default;
          editor.model.change((writer) => {
            const link = writer.createElement("link", { href: url });
            writer.insertText(
              file.name,
              link,
              editor.model.document.selection.getFirstPosition()
            );
          });
        });
      };

      input.click();
    });

    return view;
  });
}

export default {
  name: "imageUpload",
  jsonData: {
    total: 25,
    limit: 10,
    skip: 0,
    links: {
      previous: undefined,
      next: function () {},
    },
  },
  data() {
    return {
      editUserNameField: "",
      selectedUserId: null,
      files: [],
      userDataFullscreen: true,
      call: {
        id: 0,
        status: 0,
      },
      ticketFiles: [],
      pendingTicketFiles: [],
      showFilesModal: false,
      uploadingTicketFiles: false,
      showAutoModal: false,
      showOccurrencesModal: false,
      showScenariosModal: false,
      occurrencesSummary: [],
      scenariosSummary: [],
      autoMessages: [],
      interaction: {
        description: "",
      },
      status: {
        class: "secondary",
        text: "Carregando...",
      },
      allstatus: [],
      systems: [],
      allusers: [],
      autoMessage: null,
      departments: [],
      system_error_id: "",
      cancel: [],
      call_interactions: [],
      delete_text: "",
      call_status_id: "",
      text: "",
      text_responsable: "",
      ticketProgress: [],
      editor: ClassicEditor,
      editorConfig: {
        width: "800px",
        height: "400px",
        extraPlugins: [MyUploadAdapterPlugin],
      },
      editorDisabledConfig: {
        toolbar: {
          items: [],
        },
      },
      pageLoading: true,
      loading_cancel: false,
      user_logged: {},
      ticketModalReleases: [],
      ticketSelectedReleaseId: null,
      savingTicketRelease: false,
    };
  },
  computed: {
    isAuthor() {
      return (
        this.call.user_model &&
        this.$store.state.user.id === this.call.user_model.id
      );
    },
    isAccessNivel8() {
      return this.$store.state.user.perfil_id === 8;
    },
    isAccessNivel20() {
      return this.$store.state.user.perfil_id === 20;
    },
    occurrencesButtonClass() {
      if (!this.occurrencesSummary.length) return "btn-outline-secondary";
      if (
        this.occurrencesSummary.some((o) =>
          ["pendente", "em_atuacao"].includes(o.status)
        )
      )
        return "btn-warning";
      return "btn-success";
    },
    occurrencesPendingCount() {
      return this.occurrencesSummary.filter((o) =>
        ["pendente", "em_atuacao"].includes(o.status)
      ).length;
    },
    scenariosButtonClass() {
      if (!this.scenariosSummary.length) return "btn-outline-secondary";
      if (this.scenariosSummary.some((s) => s.status === "pendente"))
        return "btn-warning";
      return "btn-success";
    },
    scenariosPendingCount() {
      return this.scenariosSummary.filter((s) => s.status === "pendente")
        .length;
    },
  },
  methods: {
    fetchModuleSummaries(callId) {
      const api = this.$store.state.api;
      axios
        .get(api + `calls/${callId}/occurrences`)
        .then((res) => {
          this.occurrencesSummary = res.data.data || res.data;
        })
        .catch(() => {});
      axios
        .get(api + `calls/${callId}/test-scenarios`)
        .then((res) => {
          this.scenariosSummary = res.data.data || res.data;
        })
        .catch(() => {});
    },
    saveEditedUserName() {
      if (!this.selectedUserId) {
        this.$message("Erro", "Selecione um usuário válido.", "error");
        return;
      }

      const api = this.$store.state.api + "calls/" + this.call.id;

      axios
        .patch(api, {
          user_id: this.selectedUserId,
        })
        .then(() => {
          this.$message("Sucesso", "Usuário do chamado atualizado!", "success");

          // Atualiza na tela imediatamente
          const newUser = this.allusers.find(
            (u) => u.id === this.selectedUserId
          );

          if (newUser) {
            this.call.user_model = newUser;
            this.call.user = newUser.name; // atualiza o campo "Usuário do Sistema"
          }
        })
        .catch((error) => {
          this.$message(
            "Erro",
            error.response?.data || "Não foi possível alterar o usuário",
            "error"
          );
        });
    },

    // === SUAS FUNÇÕES JÁ EXISTENTES ===
    // URLs assinadas geradas pela API; montar pelo ID resultaria em 403
    ticketFileUrl(f) {
      return f.download_url;
    },

    interactionFileUrl(f) {
      return f.download_url;
    },

    getTicketFiles() {
      if (!this.call?.id) return Promise.resolve();
      const api =
        this.$store.state.api + `call_attachments?call_id=${this.call.id}`;

      return axios
        .get(api)
        .then((res) => {
          this.ticketFiles = res.data?.data || [];
        })
        .catch((err) => {
          this.$message(
            null,
            err.response?.data || "Erro ao listar anexos do chamado",
            "error"
          );
        });
    },

    onTicketFilesSelected(e) {
      const files = Array.from(e.target.files || []);
      this.pendingTicketFiles.push(...files);
      e.target.value = "";
    },

    uploadTicketFiles() {
      if (!this.pendingTicketFiles.length || !this.call?.id) return;

      this.uploadingTicketFiles = true;

      const api = this.$store.state.api + "call_attachments/";
      const form = new FormData();
      form.append("call_id", this.call.id);
      this.pendingTicketFiles.forEach((f) => form.append("files[]", f));

      axios
        .post(api, form)
        .then(() => {
          this.$message("Sucesso", "Arquivos enviados com sucesso", "success");
          this.pendingTicketFiles = [];
          return this.getTicketFiles();
        })
        .catch((err) => {
          this.$message(
            null,
            err.response?.data || "Erro ao enviar arquivos",
            "error"
          );
        })
        .finally(() => {
          this.uploadingTicketFiles = false;
        });
    },

    getInteractionFiles() {
      const self = this;
      const api =
        self.$store.state.url +
        "call_interaction_files/?call_id=" +
        self.call.id;

      axios
        .get(api)
        .then((response) => {
          self.call_interactions = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    onFileChange(e) {
      this.files = Array.from(e.target.files || []);
      e.target.value = "";
    },

    loadAutoMessages(statusId) {
      const self = this;
      if (!statusId) {
        self.$message("Erro", "Status do chamado não está definido", "error");
        return;
      }

      const api = self.$store.state.api + "message_types/by-status/" + statusId;

      axios
        .get(api)
        .then((response) => {
          const list = response.data;
          if (list.length === 0) {
            self.$message(
              "Info",
              "Nenhuma mensagem automática encontrada.",
              "info"
            );
          } else {
            self.interaction.description = list[0].description;
            self.autoMessages = list;
            self.showAutoModal = true;
          }
        })
        .catch(() => {
          self.$message(
            "Erro",
            "Erro ao buscar mensagens automáticas",
            "error"
          );
        });
    },

    fillFromAutoMessage(messageObj) {
      this.interaction.description = messageObj.name; // name contém o conteúdo do CKEditor
      this.showAutoModal = false;
    },

    saveInteraction() {
      const self = this;
      const api = self.$store.state.api + "call_interactions/";

      const formData = new FormData();
      formData.append("call_id", self.call.id);
      formData.append("user_id", self.$store.state.user.id);
      formData.append("status", self.call.status);
      formData.append("description", self.interaction.description || "");

      // Troque "attachments[]" se sua API usar outro nome (ex.: "files[]")
      this.files.forEach((file) => {
        formData.append("files[]", file);
      });

      self.$loading(true);

      axios
        .post(api, formData) // não force Content-Type; o browser seta o boundary
        .then(() => {
          self.$message("Sucesso", `Interação salva com sucesso`, "success");
          self.interaction.description = "";
          self.files = [];
          self.getCall(self.call.id);
          self.getInteractions();
        })
        .catch((error) => {
          self.$message(
            null,
            error.response?.data || "Erro ao salvar interação",
            "error"
          );
        })
        .finally(() => {
          self.$loading(false);
        });
    },

    deleleTicket: function () {
      const self = this;

      // Validação do texto de cancelamento
      if (!self.delete_text.trim()) {
        self.$message(
          "Erro",
          "Por favor, descreva o motivo do cancelamento",
          "error"
        );
        return;
      }

      // Ativa o loading
      self.loading_cancel = true;

      const api = self.$store.state.api + "cancel_reasons/";

      let data = {};
      data.description = self.delete_text;
      data.ticket_id = self.$route.params.id;
      data.user_id = self.$store.state.user.id;

      axios
        .post(api, data)
        .then(() => {
          // Fecha o modal
          $("#deleteModal").modal("hide");

          // Mensagem de sucesso
          self.$message(
            "Sucesso",
            `Chamado #${String(data.ticket_id).padStart(
              6,
              "0"
            )} cancelado com sucesso!`,
            "success"
          );

          // Limpa o texto
          self.delete_text = "";

          // Atualiza o chamado
          self.getCall(data.ticket_id);
        })
        .catch((error) => {
          self.$message(
            "Erro",
            error.response?.data?.message || "Erro ao cancelar o chamado",
            "error"
          );
        })
        .finally(() => {
          // Desativa o loading
          self.loading_cancel = false;
        });
    },

    alterDepartment() {
      const self = this;
      const api = self.$store.state.api + "calls/" + self.call.id;

      axios
        .patch(api, { department_id: self.call.department_id })
        .then(() => {
          self.$message("Sucesso", `Departamento alterado!`, "success");
          self.getCall(self.call.id);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getCall: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "calls/" +
        id +
        "?with[]=project&with[]=client&with[]=client_contact&with[]=status_calls&with[]=user_model&with[]=dev&with[]=type_call&with[]=department&with[]=release";

      axios
        .get(api)
        .then((response) => {
          self.call = response.data.data[0];
          if (self.call.type_call_id == null) {
            self.call.type_call_id = 1;
          }
          self.getTicketProgress(id);
          self.call.dev_acting_old = self.call.dev_acting;
          self.status.text = self.call.status_calls.description;
          self.status.next_class =
            self.call.status_calls.badge_description_next;
          self.status.next_text = self.call.status_calls.description_next;
          self.getInteractions();
          self.user_logged = self.$store.state.user.id;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getInteractions() {
      const self = this;
      const api =
        self.$store.state.api +
        "call_interactions/?call_id=" +
        self.call.id +
        "&orderByDesc=id&with[]=user&with[]=files"; // <-- adiciona files

      axios
        .get(api)
        .then((response) => {
          self.call_interactions = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getCancelReason: function (id) {
      const self = this;
      const api = self.$store.state.api + "cancel_reasons?ticket_id=" + id;

      axios
        .get(api)
        .then((response) => {
          self.cancel = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getDepartments() {
      const self = this;
      const api = self.$store.state.api + "departments"; // ajuste conforme sua rota

      return axios
        .get(api)
        .then((response) => {
          self.departments = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getTicketProgress: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "ticket_progresses?ticket_id=" +
        id +
        "&orderByAsc=next_status&with[]=user_fineshed";

      axios
        .get(api)
        .then((response) => {
          self.ticketProgress = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getTicket: function () {
      const self = this;
      const api = self.$store.state.api + "get_ticket/";
      let data = {};

      data.ticket = self.$route.params.id;
      data.user = self.$store.state.user.id;
      data.jira_issue_id = self.call.jira_issue_id;
      data.jira_key = self.call.project.jira_key;

      axios
        .post(api, data)
        .then(() => {
          self.getCall(data.ticket);
          self.getTicketProgress(data.ticket);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    assumirChamado: function () {
      const self = this;

      // Verificar se o usuário já é o responsável
      if (self.call.dev_acting == self.$store.state.user.id) {
        self.$message(
          "Erro",
          "Você já é o responsável por este chamado!",
          "error"
        );
        return false;
      }

      // Atualizar o chamado diretamente com novo responsável e status
      const api = self.$store.state.api + "calls/" + self.call.id;

      // Preparar os dados para atualização
      const updatedCall = { ...self.call };
      updatedCall.dev_acting = self.$store.state.user.id; // Novo responsável
      updatedCall.status = 2; // Atendimento N1 (ID correto)
      delete updatedCall.closed_at; // Remove data de fechamento se existir


      axios
        .put(api, updatedCall)
        .then(() => {
          self.$message("Sucesso", "Chamado assumido com sucesso!", "success");
          // Recarregar os dados do chamado
          self.getCall(self.call.id);
          self.getTicketProgress(self.call.id);
        })
        .catch((error) => {
          console.error("Erro ao assumir chamado:", error);
          console.error("Response data:", error.response?.data);
          self.$message(
            null,
            error.response?.data || "Erro desconhecido ao assumir chamado",
            "error"
          );
        });
    },
    getAllStatus: function () {
      const self = this;
      const api = self.$store.state.api + "statusCall/?paginated=false";

      return axios
        .get(api)
        .then((response) => {
          self.allstatus = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getUsers: function () {
      const self = this;
      const api = self.$store.state.api + "users/?limit=9999";

      return axios
        .get(api)
        .then((response) => {
          self.allusers = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getSystems: function () {
      const self = this;
      const api = self.$store.state.api + "projects?paginated=false";

      return axios
        .get(api)
        .then((response) => {
          self.systems = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    saveTicketProgress: function () {
      const self = this;
      const api = self.$store.state.api + "ticket_progresses/";
      let data = {};
      data.text = self.text;
      data.status = self.call.status;
      data.ticket = self.$route.params.id;

      axios
        .post(api, data)
        .then(() => {
          self.$message("Sucesso", `Chamado avançado com sucesso`, "success");

          self.text = "";
          self.getTicketProgress(data.ticket);
          self.getCall(data.ticket);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    saveAlterStatus: function () {
      const self = this;
      let data = {};
      const api = self.$store.state.api + "logStatusCall";
      if (self.call.status == self.call_status_id) {
        self.$message(
          "Erro",
          "Status escolhido é o mesmo do chamado!",
          "error"
        );
        return false;
      }

      data.description = self.text;
      data.description_2 = self.text;
      data.id_status_old = self.call.status;
      data.id_status_new = self.call_status_id;
      data.id_calls = self.call.id;

      axios
        .post(api, data)
        .then(() => {
          self.alterStatus(); // AGORA FUNCIONA, porque alterStatus foi corrigida
          self.getCall(self.call.id);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    saveAlterResponsible: function () {
      const self = this;
      let data = {};
      const api = self.$store.state.api + "logAlterResponsible";

      if (self.call.dev_acting == "" || self.call.dev_acting == 0) {
        self.$message("Erro", "Selecione um responsável!", "error");
        return false;
      }

      if (self.call.dev_acting == self.call.dev_acting_old) {
        self.$message(
          "Erro",
          "Responsável escolhido é o mesmo do chamado!",
          "error"
        );
        return false;
      }
      data.description = self.text_responsable;
      data.id_responsable_old = self.call.dev_acting_old;
      data.id_responsable_new = self.call.dev_acting;
      data.id_calls = self.call.id;

      axios
        .post(api, data)
        .then(() => {
          self.alterReponsable();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    alterSystem: function () {
      const self = this;
      const api = self.$store.state.api + "calls/" + self.call.id;

      axios
        .patch(api, {
          system_error_id: self.call.system_error_id,
          department_id: self.call.department_id,
        })
        .then(() => {
          self.$message("Sucesso", `Sistema alterado!`, "success");
          self.getCall(self.call.id);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    alterPriority: function () {
      const self = this;
      const api = self.$store.state.api + "calls/" + self.call.id;

      axios
        .patch(api, {
          priority: self.call.priority,
          department_id: self.call.department_id,
        })
        .then(() => {
          self.$message("Sucesso", `Prioridade alterada!`, "success");
          self.getCall(self.call.id);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    alterDeadline: function () {
      const self = this;
      const api = self.$store.state.api + "calls/" + self.call.id;

      axios
        .patch(api, {
          deadline: self.call.deadline,
          department_id: self.call.department_id,
        })
        .then(() => {
          self.$message("Sucesso", `Prazo alterado!`, "success");
          self.getCall(self.call.id);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    alterStatus: function () {
      const self = this;
      const api = self.$store.state.api + "calls/" + self.call.id;

      // Atualiza o status visualmente no frontend
      self.call.status = self.call_status_id;

      // Cria um objeto APENAS com os dados que devem ser atualizados no backend
      const payload = {
        status: self.call_status_id,
        closed_at: null, // Enviar null força o banco de dados a limpar essa data
      };

      axios
        .patch(api, payload) // <-- Enviamos o payload parcial em vez de self.call inteiro
        .then(() => {
          self.$message("Sucesso", `Status alterado!`, "success");
          // Ao buscar o chamado novamente, a data de abertura original intocada voltará
          self.getCall(self.call.id);
          self.getAutoMessage();
        })
        // ... restante do seu código (catch, etc)

        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    alterReponsable: function () {
      const self = this;
      const api = self.$store.state.api + "calls/" + self.call.id;
      axios
        .put(api, self.call)
        .then(() => {
          self.$message("Sucesso", `Responsável alterado!`, "success");
          self.getCall(self.call.id);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    sugestion: function (id) {
      const self = this;

      switch (id) {
        case 1:
          self.delete_text = "Chamado em duplicidade";
          break;
        case 2:
          self.delete_text = "Problema corrigido na próxima versão";
          break;
      }
    },

    getCall(id) {
      const self = this;
      const api =
        self.$store.state.api +
        "calls/" +
        id +
        "?with[]=project&with[]=client&with[]=client_contact&with[]=status_calls&with[]=user_model&with[]=dev&with[]=type_call&with[]=department&with[]=release";

      return axios
        .get(api)
        .then((response) => {
          self.call = response.data.data[0];
          if (self.call.type_call_id == null) self.call.type_call_id = 1;
          self.getTicketProgress(id);
          self.call.dev_acting_old = self.call.dev_acting;
          self.status.text = self.call.status_calls.description;
          self.status.next_class =
            self.call.status_calls.badge_description_next;
          self.status.next_text = self.call.status_calls.description_next;
          self.getInteractions(); // aqui já chama, depois que call.id existe
          self.user_logged = self.$store.state.user.id;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getAutoMessage() {
      const self = this;

      if (!self.call.status) {
        self.autoMessage = null;
        return;
      }

      const api =
        self.$store.state.api +
        "message_types?call_status_id=" +
        self.call.status;

      axios
        .get(api)
        .then((response) => {
          const mensagem = response.data.data[0];
          self.autoMessage = mensagem ? mensagem.name || mensagem.reason : null;
        })
        .catch(() => {
          self.autoMessage = null;
        });
    },

    openTicketReleaseModal() {
      this.ticketSelectedReleaseId = null;
      this.ticketModalReleases = [];
      if (this.call.system_error_id) {
        axios
          .get(
            this.$store.state.api +
              `releases?project_id=${this.call.system_error_id}&paginated=false&status=planejada`
          )
          .then((res) => {
            const data = res.data.data || res.data;
            this.ticketModalReleases = data.map((r) => ({
              ...r,
              release_label: `${r.version_string} — ${r.name} (${r.status})`,
            }));
          })
          .catch(() => {});
      }
      $("#ticketReleaseModal").modal("show");
    },

    attachReleaseToTicket() {
      if (!this.ticketSelectedReleaseId) return;
      this.savingTicketRelease = true;
      axios
        .post(this.$store.state.api + "releases/attach-ticket", {
          ticket_id: this.call.id,
          release_id: this.ticketSelectedReleaseId,
        })
        .then(() => {
          const release = this.ticketModalReleases.find(
            (r) => r.id === this.ticketSelectedReleaseId
          );
          this.$set(this.call, "release", release || null);
          this.$set(this.call, "release_id", this.ticketSelectedReleaseId);
          this.$set(this.call, "status", 4);
          this.$message("Sucesso", "Chamado vinculado à release!", "success");
          $("#ticketReleaseModal").modal("hide");
        })
        .catch(() => {
          this.$message("Erro", "Não foi possível vincular.", "error");
        })
        .finally(() => {
          this.savingTicketRelease = false;
        });
    },

    detachReleaseFromTicket() {
      this.savingTicketRelease = true;
      axios
        .delete(
          this.$store.state.api + `releases/detach-ticket/${this.call.id}`
        )
        .then(() => {
          this.$set(this.call, "release", null);
          this.$set(this.call, "release_id", null);
          this.$message(
            "Sucesso",
            "Chamado desvinculado da release!",
            "success"
          );
          $("#ticketReleaseModal").modal("hide");
        })
        .catch(() => {
          this.$message("Erro", "Não foi possível desvincular.", "error");
        })
        .finally(() => {
          this.savingTicketRelease = false;
        });
    },
  },
  
  async mounted() {
    this.pageLoading = true;
    const id = this.$route.params.id;

    try {
      await Promise.all([
        this.getAllStatus(),
        this.getUsers(),
        this.getSystems(),
        this.getDepartments(),
      ]);

      if (id) {
        await this.getCall(id);
        this.getAutoMessage();
        await this.getTicketFiles();
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.pageLoading = false;
    }
  },

  components: {
    BaseCrud,
    vSelect,
    JsonViewer,
    ReleaseTicketsModal,
    CallOccurrences,
    CallTestScenarios,
  },
};

</script>
<style>
.module-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 1060;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 40px 16px 16px;
  overflow-y: auto;
}
.module-modal-content {
  background: #fff;
  color: #343a40;
  border-radius: 8px;
  width: 100%;
  max-width: 860px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
}
.module-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid #e0e0e0;
  background: #f8f9fa;
  border-radius: 8px 8px 0 0;
  color: #343a40;
}
.module-modal-body {
  padding: 16px 20px;
  color: #343a40;
}
/* garante que todo texto dentro do modal herde a cor escura */
.module-modal-content strong,
.module-modal-content small,
.module-modal-content label,
.module-modal-content p,
.module-modal-content h5,
.module-modal-content h6,
.module-modal-content li,
.module-modal-content td,
.module-modal-content th {
  color: inherit;
}
.module-modal-content .text-muted {
  color: #6c757d !important;
}
.module-modal-content .text-primary {
  color: #007bff !important;
}
.module-modal-content .text-success {
  color: #28a745 !important;
}
.module-modal-content .text-danger {
  color: #dc3545 !important;
}
.module-modal-content .text-warning {
  color: #ffc107 !important;
}
/* sub-modal do componente filho também precisa de fundo branco */
.module-modal-body .modal-backdrop-custom .card {
  background: #fff;
  color: #343a40;
}
.btn-hover-white {
  transition: background 0.38s cubic-bezier(0.6, 0.15, 0.18, 1.05),
    color 0.32s cubic-bezier(0.4, 0.3, 0.2, 1),
    box-shadow 0.24s cubic-bezier(0.4, 0.3, 0.2, 1);
}

.btn-hover-white:hover,
.btn-hover-white:focus {
  background: #fff !important;
  color: #232a34 !important;
  border-color: #4265ff !important;
  box-shadow: 0 4px 18px 0 rgba(66, 101, 255, 0.12),
    0 1.5px 3.5px 0 rgba(0, 0, 0, 0.05);
}

.btn-hover-white:hover i,
.btn-hover-white:focus i {
  color: #232a34 !important;
  transition: color 0.32s cubic-bezier(0.4, 0.3, 0.2, 1);
}

/* Modal backdrop */
.modal-backdrop-custom {
  position: fixed;
  z-index: 1099;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(12, 16, 32, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Modal */
.custom-modal {
  background: #232940;
  border-radius: 16px;
  padding: 28px 32px 18px 32px;
  min-width: 380px;
  max-width: 94vw;
  color: #fafbfc;
  box-shadow: 0 12px 48px #0009;
  animation: modalFadeIn 0.24s;
}

@keyframes modalFadeIn {
  from {
    transform: scale(0.95) translateY(30px);
    opacity: 0;
  }

  to {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}

.custom-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  border-bottom: 1px solid #343b59;
  padding-bottom: 8px;
  position: relative;
  min-height: 38px;
}

/* Botão X no topo direito, fora do fluxo do texto */
.custom-modal .modal-header button {
  position: absolute;
  top: -12px;
  right: -10px;
  color: #b6bad8;
  font-size: 28px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0 8px;
  line-height: 1;
  z-index: 2;
  transition: 0.18s;
}

.custom-modal .modal-header button:hover {
  color: #fff;
  transform: scale(1.17);
}

.custom-modal .modal-body {
  max-height: 280px;
  overflow-y: auto;
  padding-top: 10px;
}

/* Lista de mensagens */
.custom-modal ul {
  padding: 0;
  margin: 0;
}

.custom-modal li {
  list-style: none;
  margin-bottom: 10px;
  cursor: pointer;
  border-radius: 8px;
  padding: 13px 15px;
  background: #252f47;
  border: 1.5px solid #303960;
  font-size: 16px;
  font-weight: 500;
  transition: background 0.17s, border 0.13s, color 0.13s, box-shadow 0.15s;
}

.custom-modal li:hover {
  background: #2f3854;
  border-color: #495fff;
  color: #fff;
  box-shadow: 0 2px 16px #23294022;
}

.custom-modal .modal-footer {
  text-align: right;
  margin-top: 12px;
}

.custom-modal .btn.btn-secondary {
  background: #353b5b;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 7px 20px;
  font-weight: 500;
  font-size: 15px;
  transition: background 0.18s, color 0.13s;
}

.custom-modal .btn.btn-secondary:hover {
  background: #495fff;
  color: #fff;
}

.ck-editor__editable {
  min-height: 150px;
  color: inherit;
}

/* Estilo das interações */
.gray-50 {
  background-color: #f3f3f3 !important;
  margin-left: 70px;
}

.gray-100 {
  background-color: #d8d8d8 !important;
  margin-right: 70px;
}

.blue {
  background-color: #daecff !important;
  text-align: center !important;
}

.gray-50,
.gray-100,
.blue {
  color: #59636b !important;
}

.card .card-title {
  color: #59636b !important;
  font-weight: bold;
}

/* Limitar o tamanho das imagens nas interações */
.card-text img {
  max-width: 100% !important;
  height: auto !important;
  max-height: 400px !important;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  margin: 8px 0;
}

/* Garantir que figuras também respeitem o limite */
.card-text figure {
  max-width: 100% !important;
  margin: 8px 0 !important;
  text-align: center;
}

.card-text figure img {
  display: block;
  margin: 0 auto;
}

/* Para casos onde a imagem está em um link */
.card-text a img {
  max-width: 100% !important;
  height: auto !important;
  max-height: 400px !important;
}
</style>
